<template>
<div class="box">
  <div class="box-header with-border">
    <div style="font-size:1em;display:inline-block">
      <span data-toggle="popover" title="Help" data-content="1. Write your story below, using appropriate tags when needed - for example, if you have a piece of dialog, and would like to show some character having a sad reaction, but don't know exactly what kind of response would be best fitting - you can use [sad] as a placeholder, or [bodylanguage;sad] (if you know, what kind of reaction you would like)<br /><br />2. Each time space, enter or backspace is pressed, the engine scans for the tags and marks them with a red underline<br /><br />3. When you are finished, writing a chapter - scan it the story from top to bottom looking for the placeholder tags<br /><br />4. When you click on the tag, available hints will be shown on the right control - click on them to have the tag replaced with the hint, then re-edit as needed">
        <i style="font-size:1em;" class="fa fa-question-circle"></i>
      </span>
    </div>

    <h3 class="box-title">Hint story editor</h3>
    <!-- /.box-tools -->
  </div>
  <!-- /.box-header -->
  <div class="box-body">
    <div class="editor-text-area" ref="editor-text-area" style="overflow-y:scroll">
      <div v-html="editorTextAreaData" ref="editor-text-area-div" style="overflow-y:scroll"></div>
      <textarea v-model="editorData" ref="text-area" @keyup.enter="textAreaOnKeyUp" @keyup.space="textAreaOnKeyUp" @keyup.delete="textAreaOnKeyUp" @click="clickElementUnderneath($refs['text-area'], $event)" @scroll="fixScroll"></textarea>
      <div ref="inline-helper" style="width:100px;height:200px;background:white;visibility:hidden;position:absolute"></div>
    </div>
  </div>
  <!-- /.box-body -->
</div>
<!-- /.box -->
</template>
<script>
import localForage from "localForage";

let events = {
  onTagSelected: "onTagSelected",
  onSpanDeselected: "onSpanDeselected"
};

export default {
  name: "TextEditor",
  inject: ["storyProcessor"],
  data: function() {
    return {
      editorData: "",

      editorTextAreaData: "",

      globalSaveInterval: undefined,

      isMarkSynonyms: false
    };
  },
  components: {},
  methods: {
    loadDocumentToEdit: function() {
      var that = this;

      localForage.getItem("file1").then(function(dataFromStorage){
        if (dataFromStorage == null || dataFromStorage === "") {
          that.editorData = "Hello world [Breathing;Neutral] [Breathing;Sad]";
        } else {
          that.editorData = dataFromStorage;
        }
      });
    },

    saveData: function() {
      try {
        localForage.setItem("file1", this.editorData);
      } catch (e) {
        alert("Save failed!" + e);
      }
    },

    setSaveInterval: function() {
      var that = this;

      if (that.globalSaveInterval !== undefined) {
        clearInterval(that.globalSaveInterval);
      }
      this.globalSaveInterval = setInterval(function() {
        that.saveData();

        console.log("Save data called");

        clearInterval(that.globalSaveInterval);
      }, 1000);
    },

    textAreaOnKeyUp: function(e) {
      var textAsHTML = this.convertTextToHTML(this.editorData);
      
      textAsHTML = this.markSynonyms(textAsHTML);

      textAsHTML = this.generateTextForMarkerDiv(textAsHTML);

      this.editorTextAreaData = textAsHTML;

      this.$nextTick(function() {
        var $allSpansToProcess = $(this.$refs["editor-text-area-div"]).find(
          "span.to-process"
        );

        this.processMarkerSpans(
          $allSpansToProcess,
          this.$refs["editor-text-area-div"],
          this.$refs["text-area"]
        );
      });

      this.setSaveInterval();
    },

    createMarkerSpanAndReturnHTMLAsString: function() {
      var $markerSpanToCreate = $("<span />", {
        class: "span-underline-red to-process"
      }).html("[$1]");

      return $markerSpanToCreate[0].outerHTML;
    },

    createSynonymMarkerSpanAndReturnHTMLAsString: function() {
      var $markerSpanToCreate = $("<span />", {
        class: this.isMarkSynonyms ? "span-underline-blue to-process synonym" : "to-process synonym"
      }).html("$1");

      return $markerSpanToCreate[0].outerHTML;
    },

    markSynonyms: function(textAreaTextConvertedToHTML){
      var markerSpanToAdd = this.createSynonymMarkerSpanAndReturnHTMLAsString();

      var textAreaTextWithMarkerSpans = textAreaTextConvertedToHTML;

      var synonymKeys = this.storyProcessor.getSynonymsKeys();

      synonymKeys.forEach(x => {
        let regex = new RegExp('\\b('+x+')\\b'+'(?![^[]*])', 'gi');

        textAreaTextWithMarkerSpans = textAreaTextWithMarkerSpans.replace(
          regex,
          markerSpanToAdd
        );
      });

      return textAreaTextWithMarkerSpans;
    },

    /** Takes text from textArea and generates HTML for editor-text-area-div */
    generateTextForMarkerDiv: function(textAreaTextConvertedToHTML) {
      var markerSpanToAdd = this.createMarkerSpanAndReturnHTMLAsString();

      // var valueToProcess = this.editorData;

      // var textAreaTextConvertedToHTML = valueToProcess
      //   .replace(/  /g, " &nbsp;") //Zamień spacje na '&nbsp;'
      //   .replace(/\r?\n/g, "<br />"); //Zamień newline na '<br />'

      // var textAreaTextConvertedToHTML = valueToProcess
      //   .replace(/ /g, " ") //Zamień spacje na '&nbsp;'
      //   .replace(/\r?\n/g, "<br />"); //Zamień newline na '<br />'

      var textAreaTextWithMarkerSpans = textAreaTextConvertedToHTML.replace(
        /\[(.*?)\]/g,
        markerSpanToAdd
      );

      return textAreaTextWithMarkerSpans;

      //this.editorTextAreaData = textAreaTextWithMarkerSpans;
    },

    clickElementUnderneath: function($elementOver, event) {
      $($elementOver).css("visibility", "hidden");

      var $under = $(document.elementFromPoint(event.clientX, event.clientY));

      $under.triggerHandler("click");

      console.log($under);

      $($elementOver).css("visibility", "visible");

      if($under.is('div')){
        this.$emit(events.onSpanDeselected);
      }
    },


    processMarkerSpans: function(
      $spansToProcess,
      $editorTextAreaDiv,
      $editorTextAreaTextArea
    ) {
      var that = this;

      $.each($spansToProcess, function(key, spanToProcess) {
        var $spanToProcess = $(spanToProcess);

        $spanToProcess.on("click", function() {
          that.$emit(events.onTagSelected, $spanToProcess);

          $spanToProcess.removeClass("to-process");
        });
      });
    },

    fixScroll: function(e) {
      $(this.$refs["editor-text-area-div"]).scrollTop(e.target.scrollTop);
    },

    convertTextToHTML:function(){
      var dataToReturn = this.editorData
        .replace(/  /g, " &nbsp;")
        .replace(/\r?\n/g, "<br />");

      return dataToReturn;
    },

    /**
     * Sets whether the synonyms should be marked by an underline, or not
     * @param {Boolean} markSynonyms Bool value indicating if the option is enabled or disabled
     */
    switchSynonymsMarking: function(markSynonyms){
      this.isMarkSynonyms = markSynonyms;

      this.textAreaOnKeyUp();
    }
  },
  created: function() {
    this.loadDocumentToEdit();
  },
  mounted: function() {}
};
</script>
<style>
.editor-text-area {
  position: relative;
  height: 595px;
  background-color: white;
}

.editor-text-area * {
  margin: 0;
  padding: 0;
}

.editor-text-area div {
  border: 1px solid transparent;
  color: transparent;
  /* color: red; */
}

.editor-text-area textarea {
  resize: none;
}

.editor-text-area div,
.editor-text-area textarea {
  position: absolute;
  top: 0;
  left: 0;
  background: transparent;
  font-size: 1em;
  line-height: 1em;
  font-family: arial;
  width: 100%;
  height: inherit;
  overflow-y: scroll;
  overflow-x: hidden;
}

.editor-text-area span {
  background: transparent;
  font-size: 1em;
  line-height: 1em;
  font-family: arial;
}

.span-underline-red {
  border-bottom: 1px solid red;
}

.span-underline-blue {
  border-bottom: 1px solid blue;
}
</style>



// WEBPACK FOOTER //
// src/components/TextEditor.vue